import IScreenData from "./IScreenData";

export default class ScreenData implements IScreenData {

    mode: string;
    orientation: string;

    containerScale: number;
    containerWidthScaled: number;
    containerHeightScaled: number;
    containerWidthOrig: number;
    containerHeightOrig: number;
    containerLeft: number;
    containerTop: number;

    canvasWidthScaled: number;
    canvasHeightScaled: number;
    canvasScale: number;
    canvasWidthOrig: number;
    canvasHeightOrig: number;

    controlsScale: number;

    constructor() {}

    setOrientation(orientation: string) {
        this.orientation = orientation;
    }

    setMode(mode: string) {
        this.mode = mode;
    }

    setContainer(contData) {
        this.containerScale = contData.scale;
        this.containerWidthScaled = contData.widthScaled;
        this.containerHeightScaled = contData.heightScaled;
        this.containerWidthOrig = contData.widthOrig;
        this.containerHeightOrig = contData.heightOrig;

        this.containerTop = contData.top;
        this.containerLeft = contData.left;
    }

    setCanvas(canvasData) {
        this.canvasScale = canvasData.scale;
        this.canvasWidthScaled = canvasData.widthScaled;
        this.canvasHeightScaled = canvasData.heightScaled;
        this.canvasWidthOrig = canvasData.widthOrig;
        this.canvasHeightOrig = canvasData.heightOrig;
    }

    setControls(controlsData) {
        // this.controlsWidth = controlsData.width;
        // this.controlsHeight = controlsData.height;
        this.controlsScale = controlsData.scale;
    }



}